/**
 * Identifiers (storefront): the product's code ("Код: TS091-BL"). The server
 * sends `sku` and `ean` when the product has them (aldoo-na identifiers); a
 * project shows the code where its product details are (aldoo.com: the
 * Details tab) with `ProductCode` or its own row, so no slot is filled here.
 */
import React from "react"
import { useStoreExtensionText } from "../texts"

export function ProductCode({ product }) {
  const text = useStoreExtensionText()
  if (!product?.sku) return null
  return (
    <div className="text-[13px] text-text_secondary" data-testid="product-sku">
      {text("sku")}: <span className="font-medium text-text select-all">{product.sku}</span>
    </div>
  )
}

export const StorefrontExtension = {
  id: "identifiers",
  label: "Identifiers",
  slots: {},
}
